import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { ChildContactInfoComponent } from '@se-po/se-household-setup-feature-child-contact-info'
import { ChildInfoComponent } from '@se-po/se-household-setup-feature-child-info'
import { CreatePasswordComponent } from '@se-po/se-household-setup-feature-create-password'
import { MatchComponent } from '@se-po/se-household-setup-feature-match'
import { ParentGuardianInfoComponent } from '@se-po/se-household-setup-feature-parent-guardian-info'
import { SelfInfoComponent } from '@se-po/se-household-setup-feature-self-info'
import { VerificationComponent } from '@se-po/se-household-setup-feature-verification'
import { WhoComponent } from '@se-po/se-household-setup-feature-whos-participating'

import { CreateHouseholdComponent } from './create-household.component'

const routes: Routes = [
  {
    path: '',
    component: CreateHouseholdComponent,
    children: [
      { path: '', redirectTo: 'who', pathMatch: 'full', },
      { path: 'who', component: WhoComponent },
      { path: 'child', component: ChildInfoComponent },
      { path: 'child-contact-info', component: ChildContactInfoComponent },
      { path: 'parent-guardian-info', component: ParentGuardianInfoComponent },
      { path: 'self', component: SelfInfoComponent },
      { path: 'create-password', component: CreatePasswordComponent },
      { path: 'match', component: MatchComponent },
      { path: 'verification', component: VerificationComponent },
    ]
  }
]

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class CreateHouseholdRoutingModule { }
